export interface PostOptions {
    headers?: Record<string, string>
    /** Aborts the request after this many milliseconds. */
    timeoutMs?: number
}

export class ApiClient {

    async post(path:string, data:Record<string, any>, { headers = {}, timeoutMs }: PostOptions = {}): Promise<Response>{
        const fullUrl = this.getFullUrl(path);
        const controller = timeoutMs ? new AbortController() : null;
        const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;
        try {
            return await fetch(fullUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
                body: JSON.stringify(data),
                signal: controller?.signal,
            });
        } finally {
            if (timer) clearTimeout(timer);
        }
    }

    private getFullUrl(path:string): string {
        // replaced dynamically in vite.config.js during build
        return `__API_URL__${path}`;
    }
}
